var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"route-properties\"><section class=\"extra-padding\"><div class=\"container\"><div class=\"row center-xs\"><div class=\"col-xs-12 col-sm-6\"><h2>Select a property</h2><ul><li ng-if=\"!propertiesCtrl.leads.length\"><ul><li ng-hide=\"session.human\" class=\"primary-nav-item\"><a href=\"/login?redirectTo={{propertiesCtrl.propertiesUrl()}}\" target=\"_self\">Sign in to see your properties.</a></li><li ng-show=\"session.human\" class=\"primary-nav-item\"><a href=\"/address-entry\" target=\"_self\">Request an offer for your home first.</a></li></ul></li><li ng-repeat=\"lead in propertiesCtrl.leads\"><p class=\"prose\"><a href=\"{{lead.url}}\" target=\"_self\">{{lead.address | street}}<span ng-if=\"lead.readable_state\"> ({{ lead.readable_state }})</span></a></p></li></ul></div></div></div></section></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/properties.jade
 ** module id = 3570
 ** module chunks = 3
 **/